import { useEffect } from 'react';
import { MarketingLanding as MarketingHome, type MarketingLandingProps } from './MarketingHome.js';
import { MarketingDetail, marketingPageAt } from './MarketingDetail.js';

export const homeMetadata = {
  slug: 'ai-assistant-for-business',
  title: 'AI assistant for business — Stop doing your AI’s job',
  description: 'AI assistant for business to find answers in your chats, meetings and files. Check the proof and get the task or reply ready to approve.'
};
// Explicit public URLs also render this component for signed-in visitors. Existing business,
// confirmation, sign-in and authenticated/Voice lifecycles remain with ProductEntry.
export function MarketingSite({ pathname, ...props }: MarketingLandingProps & { pathname?: string }) {
  const path = pathname ?? (typeof window === 'undefined' ? '/' : window.location.pathname);
  const page = marketingPageAt(path);
  const metadata = page ?? homeMetadata;
  useEffect(() => {
    document.title = metadata.title;
    const setMeta = (name: string, content: string) => {
      let tag = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
      if (!tag) { tag = document.createElement('meta'); tag.name = name; document.head.append(tag); }
      tag.content = content;
    };
    setMeta('description', metadata.description);
  }, [metadata.title, metadata.description]);
  return page ? <MarketingDetail page={page} {...props} /> : <MarketingHome {...props} />;
}
export type { MarketingLandingProps };
